import React from 'react';
import withErrorCatcher from '../../../components/Common/withErrorCatcher.js'
import { compose } from 'recompose'
import Divider from '@material-ui/core/Divider';
import { connect } from 'react-redux'
import { push } from 'react-router-redux';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';
import AppContent from '@components/App/appContent';
import SingleColumnView from '@components/App/singleColumnView';
import Header from '@components/App/PageComponents/pageContentHeader';
import { AddCircle } from '@material-ui/icons';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { showSnackbar } from '../../../../actions/appActions'
import UserAvatar from '../../../components/Common/UserAvatar';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    paper: {
        padding: 30
    },
    divid: {
        marginTop: 20,
        marginBottom: 20,
        backgroundColor: 'rgba(0, 0, 0, 0.1)'
    },
    buttonIc: {
        marginTop: '8px',
        fontSize: '14px'
    },
    progress: {
        margin: `0 ${theme.spacing.unit * 2}px`,
        textAlign: 'center',
        align: 'center'
    },
    spinner: {
        textAlign: 'center',
        paddingTop: 16
    },
})

export class EditMappingPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            title: ''
        }
    }

    saveMapping = () => {
        const { dispatch, sourceService, source, goTo } = this.props;

        dispatch(showSnackbar('Saving...'));
        sourceService.editSource(source.id, this.state.userMappings).then(() => {
            dispatch(showSnackbar('Saved!'));
            goTo({ pathname: '/admin/sources' })
        })
    }

    componentWillMount() {
        if (!this.props.source) {
            this.props.goTo({ pathname: '/admin/sources' })
        }
        else {
            this.props.sourceService.getSource(this.props.source.id).then((userMappings) => {
                if (!userMappings.length) {
                    userMappings = this.props.users.map(user => {
                        return {
                            userProfile: user,
                            Source: this.props.source,
                            mapping: user.email
                        }
                    })
                }

                this.setState({
                    userMappings
                })
            });
        }
    }

    onChange = (user, newValue) => {
        const { source } = this.props;
        const { userMappings } = this.state;
        const newUserMappings = [...userMappings];

        var userMapping = newUserMappings.find(userMapping => userMapping.userProfile.id === user.id);

        if (userMapping) {
            userMapping.mapping = newValue;
        }
        else {
            newUserMappings.push = {
                userProfile: user,
                Source: source,
                mapping: newValue
            };
        }

        this.setState({ userMappings: newUserMappings });
    }

    render() {
        const { classes, users, source,t } = this.props;

        const pageTitle = {
            title: 'Edit ' + source.title,
            subtitle: 'Edit Mapping',
            avatar: <ListItemIcon>
                <AddCircle style={{ height: 48, width: 48 }} />
            </ListItemIcon>,
            description: ''
        }

        const spinner = <div data-intrcm-id="editUserSourceMapping_m08lbips" className={classes.spinner}>
            <CircularProgress className={classes.progress} />
        </div>
        let content = spinner;

        if (this.state.userMappings) {
            content = users.map(user => {
                var userMapping = this.state.userMappings
                    ? this.state.userMappings.find(userMapping => userMapping.userProfile.id === user.id)
                    : null;
                var mapping = userMapping ? userMapping.mapping : user.email;

                return <Grid container spacing={16} justify="space-between">
                    <Grid item md={6}>
                        <ListItem>
                            <UserAvatar userUUID={user.auth0_id} withShadow={false} />
                            <ListItemText
                                primary={user.firstname + " " + user.lastname}
                                secondary={user.email} />
                        </ListItem>
                    </Grid>
                    <Grid md={6}>
                        <TextField
                            style={{ width: 300 }}
                            // margin="dense"
                            value={mapping}
                            id={user.id}
                            label={t("User ID")}
                            type="text"
                            onChange={(event) => this.onChange(user, event.target.value, source.id)} />
                    </Grid>
                </Grid>
            })
        }

        return <AppContent >
            <SingleColumnView>
                <Paper className={classes.paper} elevation={1}>
                    <Grid container spacing={16} justify="space-between">
                        <Grid item md={8}>
                            <Header {...pageTitle} classes={classes} />
                        </Grid>
                        <Grid md={4}>
                            <Button
                                variant="raised"
                                onClick={this.saveMapping}
                                className={classes.buttonIc}>
                                {t('Save changes')}
                                </Button>
                        </Grid>
                    </Grid>
                    <Divider className={classes.divid} />

                    {content}

                </Paper>
            </SingleColumnView>
        </AppContent>;
    }

}

const mapStateToProps = (state) => ({
    ...state.services,
    globalData: state.globalData,
    users: state.globalData.users,
    source: state.customMappings.currentSource

})

const mapDispatchToProps = dispatch => {
    return {
        goTo: path => { dispatch(push(path)) },
        dispatch: dispatch
    }
}

export default compose(withStyles(styles),
    withTranslation('admin'),
    connect(
        mapStateToProps,
        mapDispatchToProps
    ))(EditMappingPage);


